import { presenceValidations } from '../validations';

export default {
  initialState: {
    form: {},
  },
  redirectUrl: '',
  formConfig: [
    {
      viewType: 'input',
      label: 'Salary',
      value: '{{0}}',
      keys: [
        {
          key: 'form.salary',
          format: 'currency',
        },
      ],
      getValidationConfig({ form, attemptedSubmit }) {
        const isValid = presenceValidations.isValid(
          form.salary,
          attemptedSubmit
        );
        return {
          isValid,
          errors: presenceValidations.errors,
          feedback: isValid ? null : presenceValidations.feedback,
        };
      },
    },
    {
      label: 'Dental Plan',
      viewType: 'select',
      value: '{{0}}',
      subType: 'text',
      items: [
        {
          value: '',
          label: 'Select one',
        },
        {
          value: 'base',
          label: 'Guardian Dental (Base Plan)',
        },
        {
          value: 'premium',
          label: 'Guardian Dental (Premier)',
        },
      ],
      keys: [
        {
          key: 'form.dental',
        },
      ],
      getValidationConfig({ form, attemptedSubmit }) {
        const isValid = presenceValidations.isValid(
          form.dental,
          attemptedSubmit
        );
        return {
          isValid,
          errors: presenceValidations.errors,
          feedback: isValid ? null : presenceValidations.feedback,
        };
      },
    },
    {
      label: 'Health Plan',
      viewType: 'select',
      value: '{{0}}',
      subType: 'text',
      items: [
        {
          value: '',
          label: 'Select one',
        },
        {
          value: 'hmo',
          label: 'HMO',
        },
        {
          value: 'ppo',
          label: 'PPO 150',
        },
        {
          value: 'ppoFiveHundred',
          label: 'PPO 500',
        },
      ],
      keys: [
        {
          key: 'form.health',
        },
      ],
      getValidationConfig({ form, attemptedSubmit }) {
        const isValid = presenceValidations.isValid(
          form.health,
          attemptedSubmit
        );
        return {
          isValid,
          errors: presenceValidations.errors,
          feedback: isValid ? null : presenceValidations.feedback,
        };
      },
    },
    {
      label: 'Level of Coverage',
      viewType: 'select',
      value: '{{0}}',
      subType: 'text',
      items: [
        {
          value: '',
          label: 'Select one',
        },
        {
          value: 'coverEmp',
          label: 'Employee Only',
        },
        {
          value: 'coverEmpSpouse',
          label: 'Employee and Spouse',
        },
        {
          value: 'coverEmpChild',
          label: 'Employee and Child(ren)',
        },
        {
          value: 'coverEmpSpouseChild',
          label: 'Employee and Spouse and Child(ren)',
        },
      ],
      keys: [
        {
          key: 'form.coverage',
        },
      ],
      getValidationConfig({ form, attemptedSubmit }) {
        const isValid = presenceValidations.isValid(
          form.coverage,
          attemptedSubmit
        );
        return {
          isValid,
          errors: presenceValidations.errors,
          feedback: isValid ? null : presenceValidations.feedback,
        };
      },
    },
    {
      viewType: 'input',
      label: 'Shares',
      value: '{{0}}',
      formatType: 'number',
      subType: 'text',
      keys: [
        {
          key: 'form.shares',
        },
      ],
      getValidationConfig({ form, attemptedSubmit }) {
        const isValid = presenceValidations.isValid(
          form.shares,
          attemptedSubmit
        );
        return {
          isValid,
          errors: presenceValidations.errors,
          feedback: isValid ? null : presenceValidations.feedback,
        };
      },
    },
  ],
  buttonText: 'Calculate',
};
